const ip = "xxx.xx.xxx.xx"
const mod = 'prod';
const url = mod === 'dev' ? 'https://dev.api-pos.cmay-optical.com' : 'https://api-pos.cmay-optical.com';
const port = "5000"
const URL = url===null?`http://${ip}:${port}`:url;
const Api = {
    AUTH : `${URL}/login`,
    GET_MENU : `${URL}/api/menu`,
    GET_IMG : `${URL}/api/image`,
    INSERT_LOG: `${URL}/api/log`,
    UPDATE_MENU: `${URL}/updateItem`,
    INSERT_ORDER: `${URL}/api/store_order`,
    GET_CALL_NUM: `${URL}/api/getCallNum`,
    GET_ID: `${URL}/api/getID`,
    GET_TOTAL_PRICE_TODAY: `${URL}/api/getTotalPriceToday`,
    GET_ORDER_HISTORY: `${URL}/api/getOrderHistory`
}
export default Api;
